import React from "react";
import {Redirect} from "react-router";
import {mainRoutes} from "../constants/routes";

const RedirectHome = () => <Redirect to={mainRoutes.Home} />;

export default RedirectHome;
